'use client'

import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'

import { useSearchFilterStore } from '@/entities/map'
import { MobilePeriodPicker } from '@/features/room-search'
import { cn, Slot, type StringDateRange } from '@/shared/lib'
import { Icon, TextField } from '@/shared/ui'
import { KeywordSearchTrigger } from '@/widgets/keyword-search-overlay'

import { useDateRange } from '../../lib/date-range'

type Props = {
  keyword?: string
  startDate?: string
  endDate?: string
  onSearch: () => void
  onChangeDates?: (dateRange?: StringDateRange) => void
}

export const MobileKeywordSearchBar = ({
  keyword: keywordProp,
  startDate,
  endDate,
  onChangeDates,
}: Props) => {
  const t = useTranslations('search_result.search')

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const keywordState = useSearchFilterStore(state => state.keyword)
  const keyword = isMounted ? keywordState : keywordProp

  const filterState = useSearchFilterStore(state => state.filters)
  const { dateRange } = useDateRange({
    startDate: isMounted ? filterState.startDate : startDate,
    endDate: isMounted ? filterState.endDate : endDate,
  })

  return (
    <div className="flex h-[57px] border-b border-b-gray-100 bg-white px-4 py-[3px]">
      <KeywordSearchTrigger className="w-3/5">
        <TextField
          value={keyword}
          readOnly
          placeholder={t('mobile_placeholder')}
          className="w-full border-none bg-[rgba(0,0,0,0)] text-[15px]! leading-[22px]! *:placeholder:text-gray-400 read-only:bg-white"
          padding={{
            x: 0,
            y: 13,
          }}
        >
          <Slot name="left">
            <Icon
              name="search"
              size={24}
              className="text-black"
              strokeWidth={1.5}
            />
          </Slot>
        </TextField>
      </KeywordSearchTrigger>
      <MobilePeriodPicker onChange={onChangeDates} className="w-2/5 shrink-0">
        <TextField
          value={dateRange}
          placeholder={t('mobile_dates')}
          readOnly
          tabIndex={-1}
          type="text"
          className={cn(
            'cursor-pointer border-none bg-[rgba(0,0,0,0)] text-[15px]! leading-[22px]!',
            '*:placeholder:text-gray-400 *:read-only:cursor-pointer',
            'focus-visible:outline-none',
          )}
          padding={{
            x: 0,
            y: 13,
          }}
        >
          <Slot name="left">
            <Icon
              name="calendar"
              className="text-black"
              size="24"
              strokeWidth={1.5}
            />
          </Slot>
        </TextField>
      </MobilePeriodPicker>
    </div>
  )
}
